export const requestsSelector = (state) => state.requests || {};

export const requestStatusSelector = (reqId) => (state) => {
  const { reqs = {} } = requestsSelector(state);
  return reqs[reqId];
};
